//===================================================
// 1.Load,Init,Settings
//===================================================
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  DEFAULT_COUNTRY_CCA3,
  GENERAL_CLEANING,
  NUMBER_OF_BATHROOMS,
  NUMBER_OF_ROOMS,
} from "../../../common/Constants";
import { checkPhoneNumber, validateValidEmail } from "../../../common/Utility";
import {
  GetAuthValues,
  setIsLoginSuccess as setIsLoginSuccessAction,
} from "../../../redux/modules/Auth";
import { setSelectedAddress as setSelectedAddressAction } from "../../../redux/modules/Book";

import { format } from "date-fns";

import appStoreButton from "../../../assets/btn-app-store.png";
import googlePlayButton from "../../../assets/btn-google-play.png";

// Material-ui
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";

// Material-ui icon
import {
  ExpandMore,
  CalendarMonthOutlined,
  CleaningServicesOutlined,
  LocationOnOutlined,
  PersonOutlineOutlined,
  PhoneInTalkOutlined,
} from "@mui/icons-material";

// custom components
import { BookingSummary, InformationForm } from "..";
import {
  CustomDateTimePicker,
  CustomSearchLocation,
  CustomSnackBarMessage,
  ManualAddressForm,
} from "../../atoms";

// css *required
import { useStyles } from "./index.css";

//===================================================
// 2.Main Component
//===================================================
const BookingForm = (props) => {
  // 2-1. useStyles *require
  const classes = useStyles();
  const theme = useTheme();

  // 2-2. Store
  const { accessToken, userInfo, address } = GetAuthValues();
  const dispatch = useDispatch();
  const selectedAddress = useSelector((state) => state.book.selectedAddress);
  const setSelectedAddress = (address) =>
    dispatch(setSelectedAddressAction(address));
  const isLoginSuccess = useSelector((state) => state.auth.isLoginSuccess);
  const setIsLoginSuccess = (value) => setIsLoginSuccessAction(value);

  const listTotalHoursPerRoom = {
    0: 0,
    1: 3,
    2: 3,
    3: 3,
    4: 4,
    5: 4,
  };
  const [isAgreeWithTermsAndPolicy, setIsAgreeWithTermsAndPolicy] =
    useState(false);
  const [showDateTime, setShowDateTime] = useState(false);
  const [isShowTypeOfArea, setIsShowTypeOfArea] = useState(false);
  const [selectedEnquiry, setSelectedEnquiry] = useState("");
  const [selectedAddons, setSelectedAddons] = useState("1"); //0. end of lease 1. general cleaning
  const [isShowNumberOfRooms, setIsShowNumberOfRooms] = useState(false);
  const [isShowInformation, setIsShowInformation] = useState(false);
  const [numberOfRoomsStudio, setNumberOfRoomsStudio] = useState(0);
  const [numberOfBathRoom, setNumberOfBathRoom] = useState(0);
  const [totalCost, setTotalCost] = useState("");
  const [totalCharge, setTotalCharge] = useState(0);
  const [totalHours, setTotalHours] = useState(
    listTotalHoursPerRoom[numberOfRoomsStudio]
  );
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [serviceInfo, setServiceInfo] = useState({
    room: 0,
    bathroom: 0,
  });
  const [isDisabledFields, setIsDisabledFields] = useState(false);
  const [addons, setAddons] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(
    DEFAULT_COUNTRY_CCA3
  );

  // 2-2. Store
  const currentDate = new Date();
  const currentHour = currentDate.getHours();

  let addDate = 1;
  if (currentHour >= 23) {
    addDate = 2;
  }

  currentDate.setDate(currentDate.getDate() + addDate);
  const [preparedData, setPreparedData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    fullAddress: "",
    street: "",
    suburb: "",
    state: "",
    country: "Australia",
    zipcode: "",
    longitude: "",
    latitude: "",
    bookingDateTime: format(
      new Date(
        new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          7,
          0
        )
      ),
      "yyyy-MM-dd hh:mm a"
    ),
    service: "",
    serviceInfo: "",
    bookingStatus: "",
    total: "",
    bookingFrom: "",
    notes: "",
    addOns: "",
    numberOfHours: "",
  });
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false); //
  const [showManualAddress, setShowManualAddress] = useState(false);
  const [manualAddress, setManualAddress] = useState({});
  const [expanded, setExpanded] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    // Remove empty value pairs
    setPreparedData((data) => {
      const newData = { ...data };
      for (const [key, value] of Object.entries(newData)) {
        if (!value || value.toString().trim() === "") {
          delete newData[key];
        }
      }
      return newData;
    });
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      const sendBooking = async () => {
        try {
          setIsLoading(true);
          const response = await axios.post("/api/booking", preparedData);
          if (response.status === 201) {
            if (preparedData?.note) {
              await axios.post(
                `/api/booking/booking-notes/${response?.data?.invoice?.bookingId}`,
                { bookingNote: preparedData?.note }
              );
            }

            await axios.post("/api/calendar", {
              bookingId: response?.data?.booking?._id,
            });

            await axios.post("/api/notification/booking", {
              bookingId: response?.data?.booking?._id,
            });

            navigate("/booking/" + response?.data?.invoice?._id, {
              state: { bookingId: response?.data?.booking?._id },
            });
          }

          setIsLoading(false);
          setFormErrors({ message: response.data.error });
        } catch (error) {
          setIsLoading(false);
          setFormErrors({ message: error.response?.data?.message || error.message || "Booking failed" });
          console.log(error);
        }
      };
      sendBooking();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- booking submit gated by formErrors/isSubmit; full deps would resubmit on unrelated updates
  }, [formErrors, isSubmit]);

  useEffect(() => {
    if (selectedAddress !== "" && accessToken) {
      setShowDateTime(true);
    }
  }, [selectedAddress, accessToken]);

  useEffect(() => {
    if (!accessToken) {
      setShowDateTime(false);
      setIsShowInformation(false);
      setIsShowTypeOfArea(false);
      setIsShowNumberOfRooms(false);
      setSelectedCountry(DEFAULT_COUNTRY_CCA3);
      setSelectedAddress({
        fullAddress: "",
        street: "",
        suburb: "",
        state: "",
        country: "Australia",
        zipcode: "",
        longitude: "",
        latitude: "",
      });
      setSelectedEnquiry("");
      setAddons([]);
      setIsDisabledFields(false);
    }

    if (accessToken) {
      setShowDateTime(true);
      setPreparedData({
        ...preparedData,
        ...address[0],
        firstName: userInfo.firstname,
        lastName: userInfo.lastname,
        phone: userInfo.phone,
        email: userInfo.email,
      });
      setSelectedAddress({ ...selectedAddress, ...address[0] });
      setIsDisabledFields(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync profile/address when login state flips; preparedData/address spread is intentional one-shot on accessToken change
  }, [accessToken]);

  useEffect(() => {
    if (showManualAddress) {
      const { state, zipcode, street_address, suburb } = selectedAddress;
      if (
        state !== "" &&
        zipcode !== "" &&
        street_address !== "" &&
        suburb !== ""
      ) {
        setShowDateTime(true);
      }
    }
  }, [selectedAddress, showManualAddress]);

  // showMain
  return showMain({
    ...props,
    classes,
    showDateTime,
    setShowDateTime,
    isShowTypeOfArea,
    setIsShowTypeOfArea,
    isShowNumberOfRooms,
    setIsShowNumberOfRooms,
    numberOfRoomsStudio,
    setNumberOfRoomsStudio,
    numberOfBathRoom,
    setNumberOfBathRoom,
    totalHours,
    setTotalHours,
    listTotalHoursPerRoom,
    isShowInformation,
    setIsShowInformation,
    totalCost,
    setTotalCost,
    isLoading,
    setIsLoading,
    formErrors,
    setFormErrors,
    isSubmit,
    setIsSubmit,
    preparedData,
    setPreparedData,
    isLoginModalOpen,
    setIsLoginModalOpen,
    isLoginSuccess,
    setIsLoginSuccess,
    accessToken,
    showManualAddress,
    setShowManualAddress,
    manualAddress,
    setManualAddress,
    isAgreeWithTermsAndPolicy,
    setIsAgreeWithTermsAndPolicy,
    selectedAddress,
    setSelectedAddress,
    serviceInfo,
    setServiceInfo,
    selectedEnquiry,
    setSelectedEnquiry,
    selectedAddons,
    setSelectedAddons,
    addons,
    setAddons,
    isDisabledFields,
    setIsDisabledFields,
    totalCharge,
    setTotalCharge,
    expanded,
    setExpanded,
    selectedCountry,
    setSelectedCountry,
    theme,
  });
};

//===================================================
// 3.Export
//===================================================
export default BookingForm;

//===================================================
// 4.propTypes and defaultProps
//===================================================

//4-1. propTypes
BookingForm.propTypes = {};

//4-2. defaultProps
BookingForm.defaultProps = {};

//===================================================
// 5.Functions *require showMain()
//===================================================
/**
 * Show main
 * @param {*} props
 */

const handleExpand = (panel, props) => (event, newExpanded) => {
  const { setExpanded } = props;
  setExpanded(newExpanded ? panel : false);
};

const getBookingActiveStep = (p) => {
  if (!p.showDateTime) return 0;
  if (!p.isShowTypeOfArea) return 1;
  if (!p.selectedEnquiry) return 2;
  return 3;
};

const showMain = (props) => {
  const {
    classes,
    showDateTime,
    isShowTypeOfArea,
    isShowNumberOfRooms,
    numberOfRoomsStudio,
    isShowInformation,
    totalHours,
    setTotalCost,
    totalCost,
    isLoading,
    formErrors,
    isLoginSuccess,
    setIsLoginSuccess,
    showManualAddress,
    preparedData,
    setPreparedData,
    setIsAgreeWithTermsAndPolicy,
    selectedAddress,
    setSelectedAddress,
    selectedEnquiry,
    selectedAddons,
    addons,
    setTotalHours,
    isDisabledFields,
    setTotalCharge,
    totalCharge,
    expanded,
    selectedCountry,
    setSelectedCountry,
    theme,
  } = props;
  const activeStep = getBookingActiveStep(props);
  const sectionPaperSx = {
    p: { xs: 2, sm: 2.5 },
    mb: 2,
    borderRadius: 2,
    border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
    bgcolor: alpha(theme.palette.primary.main, 0.02),
  };

  return (
    <React.Fragment>
      <CustomSnackBarMessage
        open={isLoginSuccess}
        handleClose={() => setIsLoginSuccess(false)}
        message="Login successful"
        severity="success"
        variant="filled"
      />

      <Box
        sx={{
          width: "100%",
          maxWidth: 1200,
          mx: "auto",
          px: { xs: 1.5, sm: 2 },
          mt: { xs: 1, md: 2 },
          mb: 4,
        }}
      >
        <Stack spacing={1.5} sx={{ mb: 3 }}>
          <Typography variant="h4" component="h1" color="text.primary">
            Book a cleaning
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ maxWidth: 640, lineHeight: 1.6 }}
          >
            Choose your location and time, pick a service, then add your
            details. We will confirm everything before we arrive.
          </Typography>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            sx={{
              display: { xs: "none", md: "flex" },
              pt: 1,
              "& .MuiStepConnector-line": {
                borderColor: alpha(theme.palette.primary.main, 0.35),
              },
            }}
          >
            <Step completed={showDateTime}>
              <StepLabel>Location</StepLabel>
            </Step>
            <Step completed={isShowTypeOfArea}>
              <StepLabel>Date &amp; time</StepLabel>
            </Step>
            <Step completed={!!selectedEnquiry}>
              <StepLabel>Service</StepLabel>
            </Step>
            <Step completed={isShowInformation && !!preparedData?.email}>
              <StepLabel>Your details</StepLabel>
            </Step>
          </Stepper>
        </Stack>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Card elevation={0}>
              <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                <Paper variant="outlined" sx={sectionPaperSx}>
                  <Stack
                    direction="row"
                    spacing={1.5}
                    alignItems="flex-start"
                    sx={{ mb: 2 }}
                  >
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: 1.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: alpha(theme.palette.primary.main, 0.12),
                        color: "primary.main",
                        flexShrink: 0,
                      }}
                    >
                      <LocationOnOutlined fontSize="small" />
                    </Box>
                    <Box>
                      <Typography variant="subtitle1" component="h2">
                        Where should we clean?
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Select your country, then search your address or enter it
                        manually.
                      </Typography>
                    </Box>
                  </Stack>
                  <CustomSearchLocation
                    handleShowDateTime={() => handleShowDateTime(props)}
                    setAddress={(address) =>
                      setSelectedAddress({ ...selectedAddress, ...address })
                    }
                    selectedAddress={
                      !showManualAddress ? selectedAddress.fullAddress : ""
                    }
                    hasError={formErrors.address}
                    setShowManualAddress={() => {
                      handleShowManualAddress(props);
                    }}
                    showManualAddress={showManualAddress}
                    type="home"
                    selectedCountry={selectedCountry}
                    setSelectedCountry={setSelectedCountry}
                  >
                    {showManualAddress && (
                      <Grid container spacing={2} sx={{ p: 0 }}>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          sx={{ mt: 3 }}
                          className={classes.customPaddingTop}
                        >
                          <ManualAddressForm
                            street={selectedAddress.street}
                            suburb={selectedAddress.suburb}
                            state={selectedAddress.state}
                            zipcode={selectedAddress.zipcode}
                            country={selectedAddress.country}
                            setAddress={(address) =>
                              setSelectedAddress({
                                ...selectedAddress,
                                ...address,
                              })
                            }
                            hasError={formErrors}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </CustomSearchLocation>
                </Paper>

                {showDateTime ? (
                  <Paper variant="outlined" sx={sectionPaperSx}>
                    <Stack
                      direction="row"
                      spacing={1.5}
                      alignItems="flex-start"
                      sx={{ mb: 2 }}
                    >
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: 1.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          bgcolor: alpha(theme.palette.primary.main, 0.12),
                          color: "primary.main",
                          flexShrink: 0,
                        }}
                      >
                        <CalendarMonthOutlined fontSize="small" />
                      </Box>
                      <Box>
                        <Typography variant="subtitle1" component="h2">
                          When should we arrive?
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Pick a date and time (7:00 am–8:00 pm). We will confirm
                          availability.
                        </Typography>
                      </Box>
                    </Stack>
                    <CustomDateTimePicker
                      handleShowTypeOfArea={() => handleShowTypeOfArea(props)}
                      isShowTypeOfArea={isShowTypeOfArea}
                      setSelectedDateTime={(dateTime) =>
                        setPreparedData({
                          ...preparedData,
                          bookingDateTime: dateTime,
                        })
                      }
                    />
                  </Paper>
                ) : null}

                {isShowTypeOfArea ? showTypeOfArea(props, theme) : null}
                {selectedEnquiry === "residential" ||
                selectedEnquiry === "commercial"
                  ? showResidentialForm(props, theme)
                  : null}

                {isShowInformation ? (
                  <React.Fragment>
                    <Divider sx={{ my: 2 }} />
                    <Paper variant="outlined" sx={{ ...sectionPaperSx, mb: 0 }}>
                      <Stack
                        direction="row"
                        spacing={1.5}
                        alignItems="flex-start"
                        sx={{ mb: 2 }}
                      >
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            borderRadius: 1.5,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            bgcolor: alpha(theme.palette.primary.main, 0.12),
                            color: "primary.main",
                            flexShrink: 0,
                          }}
                        >
                          <PersonOutlineOutlined fontSize="small" />
                        </Box>
                        <Box>
                          <Typography variant="subtitle1" component="h2">
                            Contact &amp; confirmation
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            We will use these details for your booking and
                            updates.
                          </Typography>
                        </Box>
                      </Stack>
                      <InformationForm
                        isShowInformation={isShowInformation}
                        isLoading={isLoading}
                        setTermsAndPolicy={(isAgree) =>
                          setIsAgreeWithTermsAndPolicy(isAgree)
                        }
                        setInformation={(info) =>
                          setPreparedData({ ...preparedData, ...info })
                        }
                        handleSubmitBooking={(data) =>
                          handleSubmitBooking(props)
                        }
                        userInfo={preparedData}
                        hasError={formErrors}
                        disabled={isDisabledFields}
                        selectedCountry={selectedCountry}
                      />
                    </Paper>
                  </React.Fragment>
                ) : null}
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                  Get $10 off in the app
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Book faster and track your cleans on iOS or Android.
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                  <Box sx={{ flex: "1 1 45%", minWidth: 120 }}>
                    <a href="https://apps.apple.com/au/app/cleaningly/id1621797423">
                      <img
                        src={appStoreButton}
                        alt="Download on the App Store"
                        style={{ width: "100%", height: "auto", display: "block" }}
                      />
                    </a>
                  </Box>
                  <Box sx={{ flex: "1 1 45%", minWidth: 120 }}>
                    <a href="https://play.google.com/store/apps/details?id=com.tudlo.cleaningly_mobile">
                      <img
                        src={googlePlayButton}
                        alt="Get it on Google Play"
                        style={{ width: "100%", height: "auto", display: "block" }}
                      />
                    </a>
                  </Box>
                </Stack>
              </Paper>

              <Box>
                {isShowNumberOfRooms ? (
                  <BookingSummary
                    service={preparedData?.service}
                    totalRoomsStudio={numberOfRoomsStudio}
                    totalHours={totalHours}
                    totalCost={totalCost}
                    totalCharge={totalCharge}
                    setTotalCost={(cost) => setTotalCost(cost)}
                    setTotalCharge={(charge) => setTotalCharge(charge)}
                    setTotalHours={(hours) => setTotalHours(hours)}
                    selectedAddons={selectedAddons}
                    listGeneralAddons={addons}
                    isEndOfLease={selectedAddons === "0" ? true : false}
                    isDeepClean={selectedAddons === "6" ? true : false}
                    bookingDate={preparedData?.bookingDateTime}
                  />
                ) : null}
              </Box>

              <Accordion
                expanded={expanded === "note"}
                onChange={handleExpand("note", props)}
                disableGutters
                elevation={0}
                sx={{
                  border: `1px solid ${alpha(theme.palette.divider, 1)}`,
                  borderRadius: "12px !important",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="note-content"
                  id="note"
                >
                  <Typography sx={{ fontWeight: 600 }}>
                    Good to know before you book
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    Our price covers labour, equipment, supplies, insurance, and
                    service delivery.
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    Tell us about nearby parking — otherwise parking fees may
                    apply.
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    Extras such as outside windows, carpet steam cleaning, or
                    oven cleaning are quoted separately.
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    To cancel or reschedule, contact us right away — a $50 fee may
                    apply for late changes.
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "members"}
                onChange={handleExpand("members", props)}
                disableGutters
                elevation={0}
                sx={{
                  border: `1px solid ${alpha(theme.palette.divider, 1)}`,
                  borderRadius: "12px !important",
                  overflow: "hidden",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="members-content"
                  id="members"
                >
                  <Typography sx={{ fontWeight: 600 }}>
                    Cleaningly Exclusive Club
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Stack spacing={0.5}>
                    <Typography variant="body2" color="text.secondary">
                      Priority bookings
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Priority customer support
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Member rates and exclusive deals
                    </Typography>
                  </Stack>
                </AccordionDetails>
              </Accordion>

              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: alpha(theme.palette.primary.main, 0.04),
                }}
              >
                <Stack direction="row" spacing={1.5} alignItems="flex-start">
                  <PhoneInTalkOutlined color="primary" fontSize="small" />
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                      Need help?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      <Link
                        href="https://www.facebook.com/messages/t/CleaninglyHomeServices"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                      >
                        Message us
                      </Link>
                      {" · "}
                      <Link href="tel:0480039477" underline="hover">
                        0480 039 477
                      </Link>
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1.5 }}>
                      <Link
                        href="https://www.cleaningly.com.au/terms-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                      >
                        Terms &amp; cancellation policy
                      </Link>
                    </Typography>
                  </Box>
                </Stack>
              </Paper>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};

/**
 * Show type of area
 * @param {*} props
 * @returns
 */
const showTypeOfArea = (props, theme) => {
  const { classes, selectedEnquiry } = props;
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2, sm: 2.5 },
        mb: 2,
        borderRadius: 2,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        bgcolor: alpha(theme.palette.primary.main, 0.02),
      }}
      className={classes.noPaddingLeft}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="flex-start"
        sx={{ mb: 2 }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            color: "primary.main",
            flexShrink: 0,
          }}
        >
          <CleaningServicesOutlined fontSize="small" />
        </Box>
        <Box>
          <Typography variant="subtitle1" component="h2">
            What type of property is this?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Residential covers homes and apartments; commercial covers offices
            and workplaces.
          </Typography>
        </Box>
      </Stack>
      <FormControl component="fieldset" fullWidth>
        <FormLabel
          id="type-of-area"
          sx={{
            mb: 1.5,
            color: "text.secondary",
            fontSize: "0.875rem",
            fontWeight: 500,
            "&.Mui-focused": { color: "text.secondary" },
          }}
        >
          Select one
        </FormLabel>
        <RadioGroup
          aria-labelledby="type-of-area"
          name="property-type"
          value={selectedEnquiry || ""}
          onChange={(e) => handleSelectedTypeOfArea(e.target.value, props)}
        >
          <Stack spacing={1.5}>
            {[
              { value: "residential", title: "Residential", hint: "Homes & apartments" },
              { value: "commercial", title: "Commercial", hint: "Offices & workplaces" },
            ].map((opt) => (
              <Paper
                key={opt.value}
                variant="outlined"
                sx={{
                  p: 0,
                  borderRadius: 2,
                  borderColor:
                    selectedEnquiry === opt.value
                      ? "primary.main"
                      : alpha(theme.palette.divider, 1),
                  bgcolor:
                    selectedEnquiry === opt.value
                      ? alpha(theme.palette.primary.main, 0.06)
                      : "background.paper",
                  transition: "border-color 0.2s, background 0.2s",
                }}
              >
                <FormControlLabel
                  value={opt.value}
                  control={<Radio sx={{ py: 2, pl: 2 }} />}
                  label={
                    <Box sx={{ py: 1.5, pr: 2 }}>
                      <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                        {opt.title}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {opt.hint}
                      </Typography>
                    </Box>
                  }
                  sx={{
                    m: 0,
                    width: "100%",
                    alignItems: "center",
                  }}
                />
              </Paper>
            ))}
          </Stack>
        </RadioGroup>
      </FormControl>
    </Paper>
  );
};

/**
 * Show number of rooms and bathroom selection
 * @param {*} props
 * @returns
 */
const showNumberOfRoomsAndBathroom = (props) => {
  const {
    classes,
    numberOfRoomsStudio,
    serviceInfo,
    setServiceInfo,
    selectedAddons,
  } = props;
  return (
    <Box sx={{ mt: 2 }} className={classes.noPaddingLeft}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
        Rooms &amp; bathrooms
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="number-room-label">Number of rooms</InputLabel>
            <Select
              labelId="number-room-label"
              id="numberRoom"
              name="numberRoom"
              value={numberOfRoomsStudio}
              label="Number of rooms"
              onChange={(event) => getTotalHours(event.target.value, props)}
            >
              {NUMBER_OF_ROOMS.map((number) => {
                if ((number === 0 || number === 1) && selectedAddons === "2") {
                  return null;
                }
                return (
                  <MenuItem key={number} value={number}>
                    {number}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small">
            <InputLabel id="number-bath-label">Number of bathrooms</InputLabel>
            <Select
              labelId="number-bath-label"
              id="numberBathRooom"
              name="numberBathRooom"
              value={serviceInfo.bathroom}
              label="Number of bathrooms"
              onChange={(event) => {
                setServiceInfo({
                  ...serviceInfo,
                  bathroom: event.target.value,
                });
              }}
            >
              {NUMBER_OF_BATHROOMS.map((number) => (
                <MenuItem key={number} value={number}>
                  {number}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

/**
 * show form for residential
 * @param {*} props
 */
const showResidentialForm = (props, theme) => {
  const { selectedAddons } = props;
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2, sm: 2.5 },
        mb: 2,
        borderRadius: 2,
        border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
        bgcolor: alpha(theme.palette.primary.main, 0.02),
      }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="flex-start"
        sx={{ mb: 1 }}
      >
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            color: "primary.main",
            flexShrink: 0,
          }}
        >
          <CleaningServicesOutlined fontSize="small" />
        </Box>
        <Box>
          <Typography variant="subtitle1" component="h2">
            Service details
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Tell us the size of the space and the service you want.
          </Typography>
        </Box>
      </Stack>
      {showNumberOfRoomsAndBathroom(props)}
      {showResidentialAddOns(props, theme)}
      {selectedAddons === "1" || selectedAddons === "7"
        ? showGeneralCleaning(props, theme)
        : null}
    </Paper>
  );
};

/**
 * show residential addons
 * @param {*} props
 */
const ADDON_OPTIONS = [
  { value: "0", label: "End of lease" },
  { value: "1", label: "General cleaning", residentialOnly: true },
  { value: "7", label: "Commercial clean", commercialOnly: true },
  { value: "2", label: "Carpet steam cleaning" },
  { value: "3", label: "Property services" },
  { value: "4", label: "Rubbish removal" },
  { value: "5", label: "Gardening" },
  { value: "6", label: "Deep clean" },
];

const showResidentialAddOns = (props, theme) => {
  const { selectedAddons, selectedEnquiry } = props;
  const options = ADDON_OPTIONS.filter((opt) => {
    if (opt.residentialOnly && selectedEnquiry !== "residential") return false;
    if (opt.commercialOnly && selectedEnquiry !== "commercial") return false;
    return true;
  });

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5 }}>
        Main service
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Choose the service that best matches what you need. You can add extras
        below for general cleaning.
      </Typography>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          aria-labelledby="addons"
          value={selectedAddons}
          name="addOns"
          onChange={(e) => handleOnChangeSelectedAddons(e.target.value, props)}
        >
          <Stack spacing={1}>
            {options.map((opt) => (
              <Paper
                key={opt.value}
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  borderColor:
                    selectedAddons === opt.value
                      ? "primary.main"
                      : alpha(theme.palette.divider, 1),
                  bgcolor:
                    selectedAddons === opt.value
                      ? alpha(theme.palette.primary.main, 0.06)
                      : "background.paper",
                  transition: "border-color 0.2s, background 0.2s",
                }}
              >
                <FormControlLabel
                  value={opt.value}
                  control={<Radio sx={{ py: 1.5, pl: 2 }} />}
                  label={
                    <Typography
                      variant="body2"
                      sx={{ py: 1.25, pr: 2, fontWeight: 500 }}
                    >
                      {opt.label}
                    </Typography>
                  }
                  sx={{ m: 0, width: "100%", alignItems: "center" }}
                />
              </Paper>
            ))}
          </Stack>
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

const showGeneralCleaning = (props, theme) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
        Optional add-ons
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Select any extras for this visit (optional).
      </Typography>
      <FormControl component="fieldset" sx={{ width: "100%" }}>
        <Paper
          variant="outlined"
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: alpha(theme.palette.background.paper, 1),
          }}
        >
          <List dense sx={{ py: 0 }}>
            {GENERAL_CLEANING.map((value, rowIndex) => (
              <Grid container key={rowIndex} spacing={1}>
                {value.map((details, index) => (
                  <Grid key={`${rowIndex}-${index}-${details.text}`} item xs={12} sm={6}>
                    <ListItem
                      disablePadding
                      sx={{
                        borderRadius: 1,
                        px: 1,
                        py: 0.5,
                        "&:hover": {
                          bgcolor: alpha(theme.palette.primary.main, 0.04),
                        },
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 42 }}>
                        <Checkbox
                          edge="start"
                          value={details.text}
                          tabIndex={-1}
                          disableRipple
                          color="primary"
                          onChange={(event) =>
                            handleGeneralCleaningAddons(event, props)
                          }
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={details.text}
                        primaryTypographyProps={{
                          variant: "body2",
                          sx: { fontWeight: 500 },
                        }}
                      />
                    </ListItem>
                  </Grid>
                ))}
              </Grid>
            ))}
          </List>
        </Paper>
      </FormControl>
    </Box>
  );
};

/**
 * Get total hours per room/studio
 * @param {*} totalRoomsStudio
 * @param {*} props
 */
const getTotalHours = async (totalRoomsStudio, props) => {
  const {
    setNumberOfRoomsStudio,
    setTotalHours,
    listTotalHoursPerRoom,
    setPreparedData,
    preparedData,
    totalCost,
    serviceInfo,
    setServiceInfo,
  } = props;
  setNumberOfRoomsStudio(totalRoomsStudio);
  setTotalHours(listTotalHoursPerRoom[totalRoomsStudio]);
  setServiceInfo({ ...serviceInfo, ...{ room: totalRoomsStudio } });
  setPreparedData({
    ...preparedData,
    total: totalCost.replace(/\$/g, ""),
  });

  if (Array.isArray(GENERAL_CLEANING)) {
    const selectedAddons = GENERAL_CLEANING.flatMap((x) => x).find(
      (val) => val.text === "Carpet Steam Cleaning"
    );
    selectedAddons.price = Number(50 * totalRoomsStudio);
  }
};

/**
 * Validate form
 * @param {*} preparedData
 * @returns
 */
const validateForm = (preparedData, props) => {
  const { showManualAddress, isAgreeWithTermsAndPolicy, selectedAddress } =
    props;
  const errors = {};
  if (showManualAddress) {
    if (!selectedAddress.street) {
      errors.street = "Please enter street address.";
    }

    if (!selectedAddress.suburb) {
      errors.suburb = "Please enter a suburb.";
    }

    if (!selectedAddress.state) {
      errors.state = "Please enter a state.";
    }

    if (!selectedAddress.zipcode) {
      errors.zipcode = "Please enter a postcode.";
    } else if (
      !Number(selectedAddress.zipcode) ||
      selectedAddress.zipcode.length > 4
    ) {
      errors.zipcode = "Please enter a valid postcode.";
    }
  } else {
    if (!selectedAddress.fullAddress) {
      errors.address = "Please select location.";
    }
  }

  if (!preparedData.email) {
    errors.email = "Please enter your email.";
  } else if (!validateValidEmail(preparedData.email)) {
    errors.email = "Please enter a valid email.";
  }

  if (!preparedData.firstName) {
    errors.firstName = "Please enter your firstname.";
  }

  if (!preparedData.lastName) {
    errors.lastName = "Please enter your lastname.";
  }

  if (!checkPhoneNumber(preparedData.phone)) {
    errors.phoneNumber = "Please enter a valid phone number.";
  }

  if (!isAgreeWithTermsAndPolicy) {
    errors.agree = "You must agree with the terms and conditions";
  }
  return errors;
};

//===================================================
// 6.Actions
//===================================================

/**
 * Handle Show Date Time
 * @param {*} message
 * @param {*} props
 */
const handleShowDateTime = (props) => {
  const { setShowDateTime } = props;
  setShowDateTime(true);
};

/**
 * Handle Show Type of Area
 * @param {*} message
 * @param {*} props
 */
const handleShowTypeOfArea = (props) => {
  const { setIsShowTypeOfArea } = props;
  setIsShowTypeOfArea(true);
};

/**
 * Handle selected type of area
 * @param {*} message
 * @param {*} props
 */
const handleSelectedTypeOfArea = (value, props) => {
  const {
    setIsShowNumberOfRooms,
    setTotalHours,
    setNumberOfRoomsStudio,
    setIsShowInformation,
    setPreparedData,
    preparedData,
    serviceInfo,
    setServiceInfo,
    setSelectedEnquiry,
    setSelectedAddons,
  } = props;
  setIsShowInformation(true);
  setSelectedEnquiry(value);

  setPreparedData({
    ...preparedData,
    service: value,
  });

  if (value === "residential") {
    setSelectedAddons("1");
  } else {
    setSelectedAddons("7");
  }

  setIsShowNumberOfRooms(true);
  setNumberOfRoomsStudio(0);
  setTotalHours(0);
  setServiceInfo({ ...serviceInfo, ...{ room: 0, bathroom: 0 } });
};

async function handleSubmitBooking(props) {
  const {
    totalCost,
    setFormErrors,
    preparedData,
    setPreparedData,
    setIsSubmit,
    selectedAddress,
    serviceInfo,
    addons,
    totalHours,
    selectedAddons,
  } = props;
  let typeOfService = "";
  if (selectedAddons === "0") {
    typeOfService = "End of Lease";
  }

  if (selectedAddons === "1") {
    typeOfService = "General House Cleaning";
  }

  if (selectedAddons === "2") {
    typeOfService = "Carpet Steam Cleaning";
  }

  if (selectedAddons === "3") {
    typeOfService = "Property Services";
  }

  if (selectedAddons === "4") {
    typeOfService = "Rubbish Removal";
  }

  if (selectedAddons === "5") {
    typeOfService = "Gardening";
  }

  if (selectedAddons === "6") {
    typeOfService = "Deep Clean";
  }

  if (selectedAddons === "7") {
    typeOfService = "Commercial Clean";
  }

  const mergedPayload = {
    ...preparedData,
    ...selectedAddress,
    serviceInfo: JSON.stringify(serviceInfo),
    total: totalCost.replace(/\$/g, ""),
    addOns: JSON.stringify(addons),
    numberOfHours: totalHours,
    serviceType: typeOfService,
  };
  setPreparedData(mergedPayload);
  setFormErrors(validateForm(mergedPayload, props));
  setIsSubmit(true);
}

/**
 * show/hide manual address form
 * @param {*} props
 */
const handleShowManualAddress = (props) => {
  const { setShowManualAddress, showManualAddress } = props;
  setShowManualAddress(!showManualAddress);
};

/**
 * handle change for general cleaning
 * @param {*} event
 * @param {*} props
 */
const handleGeneralCleaningAddons = (event, props) => {
  const { addons, setAddons } = props;
  const value = event.target.value;
  const selectedAddons = GENERAL_CLEANING.flatMap((x) => x).find(
    (val) => val.text === value
  );
  const currentAddons = [...addons];
  if (event.target.checked) {
    currentAddons.push(selectedAddons);
    setAddons(currentAddons);
  } else {
    const filteredAddons = currentAddons.filter(
      (addons) => addons.text !== value
    );
    setAddons(filteredAddons);
  }
};

/**
 * handle onchange selected addons
 * @param {*} value
 * @param {*} props
 */
const handleOnChangeSelectedAddons = (value, props) => {
  const {
    setSelectedAddons,
    setAddons,
    setTotalHours,
    setNumberOfRoomsStudio,
    setServiceInfo,
    serviceInfo,
  } = props;
  setSelectedAddons(value);
  setAddons([]);
  setTotalHours(3);
  // END_OF_LEASE / DEEP_CLEAN pricing only exists for num 1–5; residential init uses 0 rooms.
  if (value === "0" || value === "6") {
    setNumberOfRoomsStudio((prev) => (prev === 0 ? 1 : prev));
    setServiceInfo((si) => ({
      ...si,
      room: si.room === 0 ? 1 : si.room,
    }));
  }
  if (value === "2") {
    setNumberOfRoomsStudio(2);
    setServiceInfo({ ...serviceInfo, ...{ room: 2 } });
  }
  if (value === "3") {
    setTotalHours(4);
    setNumberOfRoomsStudio(1);
  }
  if (value === "4") {
    setTotalHours(4);
    setNumberOfRoomsStudio(1);
  }
  if (value === "5") {
    setTotalHours(4);
    setNumberOfRoomsStudio(1);
  }
};
